package dev.lingvo.site.components.studio.editor

/** Two frozen viewport composites bound static drag work; the middle backing store is reused per frame. */
internal class StageSplit(width: Int, height: Int, paint: (dynamic, Int) -> Unit) {
    private val below: dynamic
    private val above: dynamic
    val middle: dynamic = createStageCanvas(width, height)
    init {
        val canvas: dynamic = createStageCanvas(width, height)
        paint(canvas.getContext("2d"), -1)
        below = canvas.transferToImageBitmap()
        paint(canvas.getContext("2d"), 1)
        above = canvas.transferToImageBitmap()
        canvas.width = 0
        canvas.height = 0
    }
    fun draw(ctx: dynamic, paintMiddle: (dynamic) -> Unit) {
        val middleContext = middle.getContext("2d")
        middleContext.setTransform(1, 0, 0, 1, 0, 0)
        middleContext.clearRect(0, 0, middle.width, middle.height)
        paintMiddle(middleContext)
        ctx.setTransform(1, 0, 0, 1, 0, 0)
        ctx.drawImage(below, 0, 0)
        ctx.drawImage(middle, 0, 0)
        ctx.drawImage(above, 0, 0)
    }
    fun close() {
        below.close()
        above.close()
        middle.width = 0
        middle.height = 0
    }
}

/** Keep canvas dimensions explicit across Kotlin/JS name mangling and captured scopes. */
internal fun createStageCanvas(width: Int, height: Int): dynamic {
    val create: (Int, Int) -> dynamic = js("(function(w, h) { return new OffscreenCanvas(w, h); })")
    return create(width, height)
}
